export default __webpack_public_path__ + "static/media/MUSKAAN KOCHAR.601d7685.jpg";